/**
 * Join the data as per the hexIds
 * @param {Array} D1 [[hexId,value]]
 * @param {Array} D2 [[hexId,value]]
 * @return {Array} [[hexid, valueFromD1, valueFromD2, valueFromD1 - valueFromD2]]
 */
export const joinHexGeoData = (D1, D2) => {
  let joinedData = [];

  let i, j;
  for (i = 0, j = 0; i < D1.length && j < D2.length; i++, j++) {
    // let value1 = D1[i][0], value2 = D2[j][0];
    if (D1[i][0] == D2[j][0]) {
      joinedData.push([D1[i][0], D1[i][1], D2[j][1], D1[i][1] - D2[j][1]]);
    } else {
      while (
        i < D1.length &&
        j < D2.length &&
        D1[i][0].localeCompare(D2[j][0]) < 0
      ) {
        joinedData.push([D1[i][0], D1[i][1], 0, D1[i][1] - 0]);
        i++;
      }
      while (
        i < D1.length &&
        j < D2.length &&
        D1[i][0].localeCompare(D2[j][0]) > 0
      ) {
        joinedData.push([D2[j][0], 0, D2[j][1], 0 - D2[j][1]]);
        j++;
      }
      i--;
      j--;
    }
  }

  // Append the remaining items:
  for (i; i < D1.length; i++) {
    joinedData.push([D1[i][0], D1[i][1], 0]);
  }
  for (j; j < D2.length; j++) {
    joinedData.push([D2[j][0], 0, D2[j][1]]);
  }

  return joinedData;
};
